import { useState, useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { Dialog } from "@mui/material";
import AddInsurance from "./add";
import ConfirmDialog from "../../../Utils/ConfirmDialog";
import MessagePopup from "../../../Utils/MessagePopup";
import TanstackTableComponents from "../../../../components/tabel";
import axiosInstance, { API_URL, FILE_URL } from "../../../Utils/url";
import TableActionItems from "../../../../components/tabel/components/actionItems";
import { useSnackbar } from "../../../../components/SnackbarProvider";
import { useLoading } from "../../../../context/loadingcontext";
import TabelStatusCard from "../../../../components/tabel/components/statusBox";
import TabelImage from "../../../../components/tabel/components/image";
import TabelPdf from "../../../../components/tabel/components/pdf";
import InsuranceViewCard from "./view";
// import LoadingSpinner from "../../loader/loadercomp";

function Insurance() {
  const [open, setOpen] = useState(false);
  const [view, setView] = useState(false);
  const [formType, setFormType] = useState(null);
  const [searchdata, setsearchdata] = useState("");
  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [insurenceList, setInsurenceList] = useState([]);
  const [openExport, setOpenExport] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [tabelCounts, setTabelCounts] = useState({
    totalItems: 0,
    totalPages: 0,
  });
  const [rowId, setRowId] = useState(null);

  const columns = [
    {
      header: "Insurance Name",
      accessorKey: "insurance_name",
      cell: (props) => <p>{props.getValue()}</p>,
      meta: {
        sticky: true,
        left: 0,
      },
    },
    {
      header: "Insurance Type",
      accessorKey: "insurance_type",
      cell: (props) => <p>{props.getValue()}</p>,
      meta: {
        sticky: true,
        left: 150,
      },
    },
    {
      header: "Policy Number",
      accessorKey: "policy_number",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "Policy File",
      accessorKey: "policy_file",
      cell: (props) => <TabelPdf url={`${FILE_URL}${props.getValue()}`} />,
    },

    {
      header: "From Date",
      accessorKey: "validate_from",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "To Date",
      accessorKey: "validate_to",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "Logo",
      accessorKey: "insurance_logo",
      cell: (props) => (
        <TabelImage
          src={`${FILE_URL}${props.getValue()}`}
          alt="Insurance Logo"
          style={{ width: 20, height: 20, objectFit: "contain" }}
        />
      ),
    },
    {
      header: "Status",
      accessorKey: "is_active",
      cell: (props) => (
        <TabelStatusCard
          bg={props.getValue() ? "#d4edda" : "#f8d7da"}
          color={props.getValue() ? "#155724" : "#721c24"}
        >
          {props.getValue() ? "Active" : "Inactive"}
        </TabelStatusCard>
      ),
    },
    {
      header: "Actions",
      accessorKey: "actions",
      cell: (props) => (
        <TableActionItems
          row={props}
          onView={onView}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
  useEffect(() => {
    setFormType(null);
  }, []);

  useEffect(() => {
    fetchInsurenceConfig(pagination.pageIndex + 1);
  }, [pagination, open]);

  const fetchInsurenceConfig = async (pageNumber, searchText) => {
    setTableLoading(true);
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/insurance-configuration/?page=${pageNumber}`
      );

      const success = response?.data?.success;
      const message = response?.data?.message;
      if (success) {
        setInsurenceList(response?.data?.data);
      } else {
        setInsurenceList([]);
      }
      setTabelCounts({
        totalItems: response?.data?.total_items,
        totalPages: response?.data?.total_pages,
      });
    } catch (err) {
      setInsurenceList([]);
    } finally {
      setTableLoading(false);
    }
  };

  const formClose = () => {
    setOpen(false);
  };
  const addRole = () => {
    setOpen(true);
    setFormType("add");
    setRowId(null);
  };

  const onView = (row) => {
    setRowId(row?.id);
    // setFormType("view");
    // setOpen(true);
    setView(true);
  };

  const onDelete = (row) => {
    console.log(row?.id, "valuess");
    deletelist(row?.id);
  };

  const onEdit = (row) => {
    setRowId(row?.id);
    setOpen(true);
    setFormType("edit");
  };

  const deletelist = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteconfirm(id),
      onClose: () => deletecancel(),
    });
  };

  const deleteconfirm = async (id) => {
    deletecancel();
    setCirleLoading(true);
    try {
      const response = await axiosInstance.delete(
        `${API_URL}v1/insurance-configuration/${id}/`
      );
      showSnackbar(response?.data?.message, "success");
    } catch (err) {
      showSnackbar(err?.response?.data?.message, "error");
    } finally {
      setCirleLoading(false);
      fetchInsurenceConfig(pagination.pageIndex + 1);
    }
  };

  const deletecancel = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => {},
    });
  };

  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <DashboardLayout
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      setOpenExport={setOpenExport}
      name="Position Master"
    >
      {/* {Loader && <LoadingSpinner />} */}
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />

      <Dialog
        open={open}
        sx={{
          "& .MuiDialog-paper": {
            width: "800px", // Set your desired width
            maxWidth: "none", // Prevent it from limiting the width to default sizes
          },
        }}
      >
        <AddInsurance
          formClose={formClose}
          formType={formType}
          setOpen={setOpen}
          rowId={rowId}
        />
      </Dialog>
      <InsuranceViewCard
        open={view}
        onClose={() => setView(false)}
        rowId={rowId}
      />
      <TanstackTableComponents
        rows={insurenceList}
        columns={columns}
        pageCount={tabelCounts.totalPages}
        recordCount={tabelCounts.totalItems}
        addTitle="Add Insurance"
        heading="Insurance Config List"
        isLoading={tableLoading} // loading enable
        isMore={false} // More options Enable
        isExport={true} // export options enable
        isUpload={true} // upload options enable
        isAdd={true} // add option enable
        isDateFilter={false} // date filter enable
        isSearch={true} // seacrh enable
        pagination={pagination}
        setPagination={setPagination}
        handleAdd={addRole}
      />
    </DashboardLayout>
  );
}

export default Insurance;
